import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "./loading";
import useWindowWidth from "./useWindowWidth";

const PollQuestion = ({ questionsToSave, saveAnswersCritical, updateAssessmentInformation, assessmentInformation, uuid, isContext, solutionExists, counts }) => {
    const { courseCode, assessmentCode } = useParams();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const width = useWindowWidth(540);

    const handleActivateClick = async () => {
        // activate if not already activated. if already activated, deactivate by passing a falsy string
        if (requestLifeCycle) return;

        if (questionsToSave && uuid in questionsToSave) {
                await saveAnswersCritical(true, uuid);
            }

        const newUuid = assessmentInformation.activeUuid !== uuid ? uuid : '';

        try {
            setRequestLifeCycle(true);
            const url = process.env.REACT_APP_EVALUATION_API_URL + `/activate-question/${courseCode}/${assessmentCode}?questionUuid=${newUuid}`
            const urlOptions = {
                method: "POST",
                credentials: "include"
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();

            if (response.status === 200) {
                updateAssessmentInformation("activeUuid", newUuid);
                updateAssessmentInformation("activeShowExplanation", false);
            } else if (response.status === 409) {
                alert(data.detail);
            } else {
                alert('Status Code: ' + response.status + ' Error: ' + data.detail);
            }

        } catch(error) {
            alert('Error: ' + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    const handleSolutionClick = async () => {
        if (requestLifeCycle) return;

        if (questionsToSave && uuid in questionsToSave) {
            await saveAnswersCritical(true, uuid);
        }

        if (!solutionExists && !assessmentInformation.activeShowExplanation) {
            alert("Please enter an explanation and save before attempting to show the explanation");
            return;
        }
        
        try {
            setRequestLifeCycle(true);
            const url = process.env.REACT_APP_EVALUATION_API_URL + `/show-solution/${courseCode}/${assessmentCode}/${uuid}`
            const urlOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    turnOn: !assessmentInformation.activeShowExplanation
                })
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();

            if (response.status === 200) {
                updateAssessmentInformation("activeShowExplanation", !assessmentInformation.activeShowExplanation);
            } else if (response.status === 409) {
                alert(data.detail);
            } else {
                alert('Status Code: ' + response.status + ' Error: ' + data.detail);
            }

        } catch(error) {
            alert('Error: ' + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }
    

    return (
        <>
            {
                requestLifeCycle ?

                <div style={{ display: "flex", justifyContent: "center", alignContent: "center", width: "100%", height: "40px" }}>
                    <Loading />
                </div>

                :

                <>
                    {
                        assessmentInformation.pollMode ?

                        <>
                            <div className="act-deact-show-stats-container">
                                <div className="top-right-item polling" onClick={handleActivateClick}>
                                    <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
                                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
                                        </svg>
                                    </div>                    
                                    {
                                        assessmentInformation.activeUuid === uuid ? 
        
                                        (!width ? "Deactivate" : "Turn Off")
            
                                        :
            
                                        (!width ? "Activate" : "Turn On")
                                    }
                                </div>
                                {
                                    !isContext && (
                                        <div className="top-right-item polling" onClick={handleSolutionClick}>
                                            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                                                </svg>
                                            </div>
                                            {
                                                assessmentInformation.activeShowExplanation && assessmentInformation.activeUuid === uuid ? 
                
                                                ("Hide " + (!width ? "Explanation" : ""))
                    
                                                :
                    
                                                ("Show " + (!width ? "Explanation" : ""))
                                            }
                                        </div>
                                    )
                                }
                            </div>
                            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div className="ready-words">
                                    <div className="count borders" style={{ color: "var(--accent-one)" }}>{counts && counts[uuid] >= 0 ? counts[uuid] : "0"}</div> Ready to continue
                                </div>
                            </div>                            
                        </>
        
                        :
        
                        <>
                        </>
                    }                        
                </>
            }
        </>
    );
}

export default PollQuestion;